import { useContext } from 'react';
import { ApptRequestsWidgetContext } from './context';

export const useApptRequestsWidget = () => {
  const context = useContext(ApptRequestsWidgetContext);

  if (!context) throw new Error('useApptRequestsWidget must be used within a ApptRequestsWidgetProvider');

  return context;
};
